import * as THREE from 'three'
import Experience from '../../Experience.js'

export default class Arrow {

    constructor(x, z) {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        this.setModel()
        this.setLight()
        this.setRotation()
        this.setPosition(x, z)
    }

    setModel()
    {
        this.model = this.resources.items.arrowModel.clone()
        this.model.scale.set(12, 10, 10)
        this.scene.add(this.model)
    }

    setLight()
    {
        this.light = new THREE.PointLight(0xfffffff, 0, 5)
        this.light.position.set(0, 10, 0)
        this.scene.add(this.light)
    }

    setRotation()
    {
        this.model.rotation.z = Math.PI / 2
    }

    setPosition(x, z)
    {
        this.model.position.set(x, 10, z)
        this.light.position.set(x, 5, z)
    }

    update()
    {
        this.model.rotation.y = this.experience.time.elapsed * 0.002

        if (this.experience.dark_mode) {
            this.light.intensity = 10
        } else {
            this.light.intensity = 0
        }
    }
}